// Local storage에 data 저장하는 함수
const saveDataToLocalStorage = (key: string, value: string[]): void => {
  localStorage.setItem(key, JSON.stringify(value));
};
export default saveDataToLocalStorage;
